import constants from '@playcastdotio/GlobalConfig';

/**
 * Stream-health NDJSON forwarder — disk file on non-release branches only.
 *
 * Mirrors PlayJector's `PLAYCAST_VERSION_IS_RELEASE` / PJLOG compiled-severity gate:
 * release-branch builds must not create diagnostic log files under ProgramData.
 * Dev / prerelease / feature branches still get `stream-health.ndjson` for field
 * replay. Console / Sentry paths are unchanged.
 *
 * The host window runs with contextIsolation on from a remote origin, so the page has no
 * filesystem access; the only path to disk is the `appendStreamHealth` preload bridge.
 * Outside host-electron (plain browser, tests) this is a no-op. Fire-and-forget: a failed
 * IPC never surfaces to the caller, and the main process serializes appends so concurrent
 * 1 Hz peers cannot interleave JSON lines.
 */
export function isStreamHealthDiskLoggingEnabled(): boolean {
  return constants.BRANCH !== 'release';
}

export function sinkStreamHealthLine(line: string): void {
  if (!isStreamHealthDiskLoggingEnabled()) return;
  try {
    const bridge = (
      window as unknown as { playcast?: { appendStreamHealth?: (l: string) => Promise<void> } }
    ).playcast;
    if (typeof bridge?.appendStreamHealth !== 'function') return;
    void bridge.appendStreamHealth(line).catch(() => undefined);
  } catch {
    // No window / no bridge — browser-hosted page or test; the line is dropped silently.
  }
}
